var cov_inl8118ma = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Dropdown/styles/index.js",
      hash = "8dbc4b5a3e4326c4f5ed87a4842727bdb022771a",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Dropdown/styles/index.js",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 29
        },
        end: {
          line: 5,
          column: 65
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var dropdownLess = {};
import genaration from '../../utils/classname';
export var dropdownClass = (cov_inl8118ma.s[0]++, genaration(dropdownLess, 'dropdown'));